import {
    MdBrightness6,
    MdFilterAlt,
    MdContrast,
    MdColorLens
} from "react-icons/md";

const EditMenuTools = ({ onToolSelect }) => {
    const editTools = [
        {
            id: 'brightness',
            label: 'Brightness',
            icon: MdBrightness6,
        },
        {
            id: 'filters',
            label: 'Filters',
            icon: MdFilterAlt,
        },
        {
            id: 'contrast',
            label: 'Contrast',
            icon: MdContrast,
        },
        {
            id: 'color',
            label: 'Color',
            icon: MdColorLens,
        },
    ];

    const handleToolClick = (toolId) => {
        if (onToolSelect) {
            onToolSelect(toolId);
        }
    };

    return (
        <div className="absolute bottom-0 w-full flex flex-col items-center justify-center mb-3">
            <div className="flex items-center gap-x-2 px-4">
                {editTools.map((tool) => {
                    const IconComponent = tool.icon;
                    return (
                        <div key={tool.id} className="flex flex-col items-center justify-center rounded-md cursor-pointer bg-[#BDE6FF] text-black w-14 p-1">
                            <IconComponent
                                className="text-[20px]"
                                onClick={() => handleToolClick(tool.id)}
                            />
                            <p className="text-[9px] mt-1 font-bold">
                                {tool.label}
                            </p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EditMenuTools;